<template>
    <b-button variant="primary" @click.stop="exportar()" v-if="mostrarBtn">
        <i class="fa fa-file-pdf-o mr-2"></i> Exportar
    </b-button>
</template>

<script>
import download from './../../../../shared/download'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => {}
        },

        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    methods: {
        exportar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .exportar(this.pagamento.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao exportar o Registro de Pagamentos',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            download(
                                response,
                                `RegistroDePagamento_${this.pagamento.protocolo}.pdf`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        mostrarBtn() {
            return (
                this.$temAcessoView('DESP-GERAIS-FINAL-PAG-03') &&
                this.$route.name == 'DespesasGerais_Finalizacao_Pagamentos_Detalhar' &&
                this.pagamento.status === pagamentoStatus.CONCLUIDO
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
